import { faEnvelope } from '@fortawesome/free-regular-svg-icons/faEnvelope';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons/faLinkedinIn';

const contact = [
  {
    link: 'mailto:info@yasin.nu',
    label: 'Email',
    icon: faEnvelope,
  },
  {
    link: 'https://www.linkedin.com/in/yboelhouwer/',
    label: 'LinkedIn',
    icon: faLinkedinIn,
  },
];

export default contact;
